import { Container, Grid, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import Logo from "../../../../../styles/img/df-logo.png";
import { CloseIcon } from "../../../../../styles/img/svg/CloseIcon";
import { useNavigate } from "react-router-dom";
import { BackIcon } from "../../../../../styles/img/svg/BackIcon";
import { UiButton } from "../../../../_uiComponents/common/UiButton";
import { SuccessIconLarge } from "../../../../../styles/img/svg/SuccessIconLarge";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  authConstants,
  commonConstants,
} from "../../../../../_redux/_constants";
import AllSetImage from "../../../../../styles/img/onboard/all-set.png";

export const ResetPasswordSuccess = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const successResetToLogin = () => {
    navigate("/");
  };

  return (
    <>
      <div className="df-user-profile df-onboard-progress-back-close df-profile-top-aligned-box">
        <Container maxWidth="md" className="df-pos-rel">
          <div className="df-user-profile__body df-pw-tab">
            <Grid container className="df-align-center">
              <Grid size={{ xs: 12, sm: 6, lg: 6, xl: 6 }} className="df-pr-2">
                <img src={AllSetImage} className="df-verify-progress-img" />
              </Grid>

              <Grid
                size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                className="text-center"
              >
                <div className="df-onboard-radio df-onboard-nic-wr df-verify-progress">
                  <h4>{t("You are all set!")}</h4>
                  <p>{t("Please use your new password to login.")}</p>

                  <div className="d-block df-verify-progress__acc-btn">
                    <UiButton
                      className="df-ui-dark-bg-btn w-100 df-onboard-radio-btn"
                      name={t("Login to your LOLC Realtime Account")}
                      onClick={successResetToLogin}
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
    </>
  );
};
